import { ConversationMessage } from "../../../../../model/integration/dto/meta/MetaConversationMessage";
import { WAMetaMessageDirection } from "../../../../../model/integration/types/whatsapp/WAMetaMessageDirection.enum";

/** How long an attachment we sent can plausibly still be on its way to our
 * storage.
 *
 * Storing our own copy happens after WhatsApp has already accepted the
 * message, so it can fail on its own - S3 being unreachable is enough. That
 * leaves a message with no mediaId and no expiry, which used to read as
 * "uploading" forever: a spinner on every page load for the life of the
 * conversation. Past this window it is not on its way, it is gone.
 */
const UPLOAD_GRACE_MS = 2 * 60 * 1000;

/** Whether an attachment with no stored copy yet is still worth waiting for. */
export const isMediaPending = (message: ConversationMessage) => {
  if (message.mediaId || message.mediaExpiredAt) {
    return false;
  }

  if (message.direction !== WAMetaMessageDirection.OUTGOING) {
    return false;
  }

  const sentAt = Number(message.timestamp) * 1000;

  // An unreadable timestamp is not a reason to spin indefinitely
  return Number.isFinite(sentAt) && Date.now() - sentAt < UPLOAD_GRACE_MS;
};
